import React from 'react';
import template from 'template/sign_up/sign_up_app';
import Config from "../../main/app/service/config";

export default class SignUpApp extends React.Component {


    constructor(props, context) {
        super(props, context);

        Config.setConfig(props.config);
        $.ajaxSetup({
            headers: {
                'X-Csrf-Token': Config.get('csrf_token')
            }
        });
    }

    render() {
        return template(this.props);
    }

}